export function hasQueryParams(item: string): boolean {
  const checkIfQueryParams = new RegExp(/\?.+=.*/g);
  return checkIfQueryParams.test(item);
}
